import { render, staticRenderFns } from "./CardResume.vue?vue&type=template&id=62a38d78&scoped=true"
import script from "./CardResume.vue?vue&type=script&lang=js"
export * from "./CardResume.vue?vue&type=script&lang=js"
import style0 from "./CardResume.vue?vue&type=style&index=0&id=62a38d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a38d78",
  null
  
)

export default component.exports